import { settings } from "imagica-corekit/dist/base/kernel/Settings";
export var youtubeVideoData = {
  source: {
    source_icon: "".concat(settings.S3CDN).concat(settings.viewAssetsPath, "vb-youtube.png"),
    source_text: "youtube"
  },
  video_image: "https://i.ytimg.com/vi/kKzqSGt_Geg/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLD0TRgz6Bb-VOe0_irj1Q9CNZ7FwQ",
  video_title: "Questionable cat decisions",
  url: "https://www.youtube.com/watch?v=kKzqSGt_Geg"
};